import React from 'react';
import PropTypes from 'prop-types';

const SearchBox = ({ name = '', onChange, onClick, placeholder, enterKeySubmit, value }) => {
  const _enterKeyPress = (e) => {
    if (e.key === 'Enter' && onClick) {
      onClick();
    }
  };
  return (
    <div className="ci-input-group no-spacing">
      <div className="ci-control">
        <div className="form">
          <input
            name={name}
            type="text"
            onChange={onChange}
            placeholder={placeholder}
            onKeyPress={enterKeySubmit ? _enterKeyPress : null}
            value={value}
          />
        </div>
      </div>
      {onClick && (
        <div className="ci-control-button input-overlay">
          <button className="button clear no-text icon-magnifingglass-left" onClick={onClick}></button>
        </div>
      )}
    </div>
  );
};

SearchBox.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  enterKeySubmit: PropTypes.bool,
  value: PropTypes.string,
};

SearchBox.defaultProps = {
  placeholder: '',
  enterKeySubmit: false,
  value: '',
};

export default SearchBox;
